module.exports = __webpack_public_path__ + "static/img/boost_your_immunity_ advice_title.b4eafc8b.png";